import { render } from "./AvatarTabletFormComponentDetails.vue?vue&type=template&id=1ef95949"
import script from "./AvatarTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./AvatarTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__